import Brand from "../utils/BrandAPI/Brand";
import CommonConfig from "./CommonConfig";

const BrandConfig = Brand.instance.config,
    SupportedLocales = ["en"],
    DEFAULT_LOCALE_REFERENCE = "en";


const Config = {
    colors: {
        ...BrandConfig.colors,
        ...CommonConfig.colors
    },
    images: {
        ...BrandConfig.images[isRetina() ? "Retina" : "Regular"],
        ...BrandConfig.images.Both,
        ...CommonConfig.images[isRetina() ? "Retina" : "Regular"],
        ...CommonConfig.images.Both
    },
    resources: {
        ...BrandConfig.resources,
        ...CommonConfig.resource
    },
    fonts: {
        ...BrandConfig.fonts,
        ...CommonConfig.fonts
    },
    styles: {
        ...BrandConfig.styles,
        ...CommonConfig.styles
    },
    paths: {
        DEFAULT: "/HowtoSwitch",
        HOW_TO_SWITCH_A: "/ASB/lp/HowtoSwitch/1",
        HOW_TO_SWITCH_B: "/ASB/lp/HowtoSwitch/2",
        HOW_TO_SWITCH_C: "/ASB/lp/HowtoSwitch/3",
        HOW_TO_SWITCH_D: "/ASB/lp/HowtoSwitch/4",
        ASB_MOBILE: "/ASB/mobile",
        GET_ASB: "/ASB/get_asb",
        EMBED_OPT_1: "/ASB/embed_opt_1",
        EMBED_OPT_1_B: "/ASB/embed_opt_1_b",
        EMBED_OPT_2: "/ASB/embed_opt_2",
        EMBED_OPT_3: "/ASB/embed_opt_3",
    },
    apis:{
        INVITE: "https://invite.avastbrowser.com",
    },
    messages: {...getMessages()}
};



function getUserLocale() {
    const queryLanguage = new URLSearchParams(window.location.search).get('browser_locale'),
        userLanguage = (queryLanguage || navigator.language).split("-")[0];

    return SupportedLocales.indexOf(userLanguage) >= 0 ? userLanguage : DEFAULT_LOCALE_REFERENCE;
}

function getMessages() {
    const userLocale = getUserLocale(),
        offeredLocale = Object.keys(CommonConfig.messages[userLocale]).length ? userLocale : DEFAULT_LOCALE_REFERENCE;

    return {
        ...BrandConfig.messages[offeredLocale],
        ...CommonConfig.messages[offeredLocale],
        offeredLocale,
        defaultLocale: DEFAULT_LOCALE_REFERENCE
    }
}

function isRetina() {
    if (window.matchMedia) {
        let mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
        return ((mq && mq.matches) || (window.devicePixelRatio > 1));
    }
}

export default Config;
